/**
 * Shared load-more + date picker logic for news/events index pages.
 * Migrated from news_index_page.html / event_index_page.html inline JS.
 */

import flatpickr from "flatpickr";
import { Ukrainian } from "flatpickr/dist/l10n/uk.js";

export function initDatePickers(): void {
  flatpickr("#pluginFrom", { locale: Ukrainian, dateFormat: "d/m/Y", allowInput: true });
  flatpickr("#pluginTill", { locale: Ukrainian, dateFormat: "d/m/Y", allowInput: true });
}

export function initDatePickerIcons(): void {
  document
    .querySelectorAll<HTMLElement>(".plugin-accessible-datepicker-icon")
    .forEach((icon) => {
      icon.addEventListener("click", (e) => {
        e.preventDefault();
        const input = icon.parentElement?.querySelector<HTMLInputElement>(
          ".plugin-accessible-datepicker-input",
        );
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (input && (input as any)._flatpickr) {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          (input as any)._flatpickr.open();
        }
      });
    });
}

export function initLoadMore(): void {
  const loadMoreBtn = document.getElementById("loadMoreBtn") as HTMLButtonElement | null;
  if (!loadMoreBtn) return;

  loadMoreBtn.addEventListener("click", function () {
    const btn = this;
    const nextPage = btn.getAttribute("data-next-page");
    const filterQs = btn.getAttribute("data-filter-qs");
    const url =
      window.location.pathname +
      "?" +
      (filterQs ? filterQs + "&" : "") +
      "page=" +
      nextPage;

    btn.textContent = "Завантаження...";
    btn.disabled = true;

    fetch(url)
      .then((r) => r.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");

        const newItems = doc.querySelectorAll("#timelineResult .timeline-block");
        const container = document.getElementById("timelineResult");
        newItems.forEach((item) => {
          container?.appendChild(document.importNode(item, true));
        });

        const newBtn = doc.getElementById("loadMoreBtn");
        if (newBtn) {
          btn.setAttribute(
            "data-next-page",
            newBtn.getAttribute("data-next-page") ?? "",
          );
          btn.textContent = "Завантажити більше матеріалів";
          btn.disabled = false;
        } else {
          btn.parentElement?.remove();
        }
      })
      .catch(() => {
        btn.textContent = "Завантажити більше матеріалів";
        btn.disabled = false;
      });
  });
}
